/* eslint-disable array-callback-return */
import axios from "axios";
import { useEffect, useState, Fragment } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./Authinfo.scss";
import Swal from "sweetalert2";
import TextareaAutosize from "react-textarea-autosize";
// import { MyContext } from "./Certified";

function Authinfo() {
  let navigate = useNavigate();
  const [radioBox, setRadioBox] = useState([]);
  const [cbBox, setCbBox] = useState([]);
  const [inputBox, setInputBox] = useState([]);
  const [formData, setFormData] = useState([]);
  // const [selectedData, setSelectedData] = useState({});
  // const [testData, setTestData] = useState([]);
  const { state } = useLocation();
  const [showModal, setShowModal] = useState(false);
  // 제품명, 모델명
  const [prdName, setPrdName] = useState("");
  const [modelName, setModelName] = useState("");
  const [menuData, setMenuData] = useState([]);
  const closeModal = () => {
    navigate(-2);
    setShowModal(false);
  };
  useEffect(() => {
    if (state?.prevData?.applyFormValues?.length > 0) {
      setShowModal(true);
    }
    getFormData();
    getMenuData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // 신청 Form data 가져오기
  const getFormData = async () => {
    const response = await axios.get("/api/task-apply-form", {
      params: {
        taskGroupId: state.id[0].id,
      },
    });
    if (response.data.length === 0) {
      Swal.fire({
        icon: "error",
        title: "오류",
        html: `${state.id[0].workflowName} 심사분야의 신청서가 준비중입니다.<br/>
        관리자에게 문의하여주세요.`,
        confirmButtonColor: "dodgerBlue",
      });
      navigate("/request/institution", { state });
    }
    setFormData(response.data);
  };

  // 제품명, 모델명 TextFieldHandler
  const textFieldHandler = (event) => {
    if (event.target.name === "prdName") {
      setPrdName(event.target.value);
    }
    if (event.target.name === "modelName") {
      setModelName(event.target.value);
    }
  };
  // Input handler
  const onChangeHandler = (item, title) => (event) => {
    setInputBox((state) => {
      const filteredState = state.filter((e) => e.targetId !== item.id);
      const tempObj = {
        targetId: item.id,
        description: event.target.value,
        parentId: item.parentId,
        title: title,
      };
      return [...filteredState, tempObj];
    });
  };
  const tonChangeHandler = (item, title) => (event) => {
    setInputBox((state) => {
      const filteredState = state.filter((e) => e.targetId !== item.id);
      const tempObj = {
        targetId: item.id,
        description: event.target.value,
        parentId: item.parentId,
        inputFirst: true,
        title: title,
      };
      return [...filteredState, tempObj];
    });
  };

  // Radio handler
  const radioHandler = (item, title) => (event) => {
    // [...checkbox, value]
    if (event.target.checked) {
      setRadioBox((state) => {
        const secondFilteredState = state.filter(
          (e) => item.parentId !== e.parentId || e.radioFirst === true
        );

        const tempObj = {
          targetId: event.target.value,
          description: item.name,
          radio: item.entryId,
          parentId: item.parentId,
          title: title,
        };
        return [...secondFilteredState, tempObj];
      });
    }
  };
  const tradioHandler = (item, title) => (event) => {
    // [...checkbox, value]
    if (event.target.checked) {
      setRadioBox((state) => {
        const filteredState = state.filter((e) => e.radio !== item.entryId);
        const tempObj = {
          targetId: event.target.value,
          description: item.name,
          radio: item.entryId,
          radioFirst: true,
          title: title,
        };
        return [...filteredState, tempObj];
      });
      const firstRadio = radioBox.filter(
        (el) => el.radioFirst === true && el.radio === item.entryId
      );
      if (firstRadio.length > 0) {
        let tempArr = [];
        for (let i = 0; i < firstRadio.length; i++) {
          for (let j = 0; j < cbBox.length; j++) {
            if (firstRadio[i].targetId !== cbBox[j].parentId) {
              tempArr.push(cbBox[j]);
            }
            if (cbBox[j].cbFirst !== undefined) {
              tempArr.push(cbBox[j]);
            }
          }
        }
        const setTempArr = new Set(tempArr);
        setCbBox([...setTempArr]);
      } else {
        setCbBox((state) => {
          const fil = state.filter(
            (el) => el.parentId !== item.targetId || el.cbFirst === true
          );
          return [...fil];
        });
      }
      setInputBox((state) => {
        if (firstRadio.length > 0) {
          let tempArr = [];
          for (let i = 0; i < firstRadio.length; i++) {
            for (let j = 0; j < inputBox.length; j++) {
              if (firstRadio[i].targetId !== inputBox[j]?.parentId) {
                tempArr.push(inputBox[j]);
              }
              if (inputBox[j]?.inputFirst !== undefined) {
                tempArr.push(inputBox[j]);
              }
            }
          }
          const setTempArr = new Set(tempArr);
          setInputBox([...setTempArr]);
        } else {
          const filteredInputBox = state.filter(
            (el) => el.parentId !== item.entryId || el.inputFirst === true
          );
          return [...filteredInputBox];
        }
      });
    }
  };

  // Checkbox handler
  const checkboxHandler = (item, title) => (event) => {
    if (event.target.checked) {
      setCbBox((state) => {
        const tempObj = {
          targetId: event.target.value,
          description: item.name,
          parentId: item.parentId,
          title: title,
        };
        return [...state, tempObj];
      });
    } else {
      setCbBox((state) => {
        const filteredState = state.filter((e) => e.targetId !== item.id);
        const secondFilteredState = filteredState.filter(
          (e) => e.parentId !== item.id
        );
        return [...secondFilteredState];
      });
    }
  };
  const tcheckboxHandler = (item, title) => (event) => {
    if (event.target.checked) {
      setCbBox((state) => {
        const tempObj = {
          targetId: event.target.value,
          description: item.name,
          parentId: item.parentId,
          cbFirst: true,
          title: title,
        };
        return [...state, tempObj];
      });
    } else {
      setCbBox((state) => {
        const filteredState = state.filter((e) => e.targetId !== item.id);
        const secondFilteredState = filteredState.filter(
          (e) => e.parentId !== item.id
        );
        return [...secondFilteredState];
      });
      setInputBox((state) => {
        const filteredInputBox = state.filter(
          (el) => el.parentId !== item.id || el.inputFirst === true
        );
        return [...filteredInputBox];
      });
      setRadioBox((state) => {
        const filteredRadioBox = state.filter(
          (el) => el.parentId !== item.id || el.radioFirst === true
        );
        return [...filteredRadioBox];
      });
    }
  };
  // 임시저장 submitHandler
  const tempSubmitHandler = async () => {
    let tempObj = {};
    tempObj.taskGroupId = state.id[0].id;
    tempObj.managerName = state.form.staffName;
    tempObj.managerDuty = state.form.staffPosition;
    tempObj.managerEmail = state.form.staffEmail;
    tempObj.managerTel = state.form.staffNum;
    tempObj.applyFormValues = [
      ...new Set(radioBox),
      ...new Set(cbBox),
      ...new Set(inputBox),
    ];
    // 질문사항 답변안한경우 return
    const formDataArr = [...new Set(formData.map((e) => e.title))].length;
    const titleArr = [...new Set(tempObj.applyFormValues.map((e) => e.title))]
      .length;
    if (formDataArr !== titleArr) {
      return Swal.fire({
        icon: "error",
        title: "오류",
        html: `모든 항목은 필수입력값입니다`,
        confirmButtonColor: "dodgerBlue",
      });
    }

    if (state.id[0].beforeId !== null) {
      // 재발급, 재평가
      tempObj.beforeId = state.id[0].beforeId;
    }
    // 지위승계
    if (state.acceptNum !== undefined) {
      tempObj.tranQualificationNum = state.acceptNum;
    }
    // 모델명, 제품명 추가
    if (
      (state.id[0].type === 1 || state.id[0].type === 4) &&
      menuData.filter((el) => el.name !== state.id[0].workflowName).length > 0
    ) {
      tempObj.prdName = prdName;
      tempObj.modelName = modelName;
    }
    // 정기심사시 모델명, 제품명 추가
    if (state.id[0].type === 2) {
      try {
        const res = await axios.get(
          `/api/apply-proc/${state?.id[0]?.beforeId}`
        );
        tempObj.prdName = res.data.prdName;
        tempObj.modelName = res.data.modelName;
      } catch (err) {
        console.log(err);
      }
    }
    // version 관리
    tempObj.confVersion = state.id[0].confVersion;
    try {
      const response = await axios.post("/api/apply-proc", tempObj);
      if (state.id[0].type === 1) {
        Swal.fire({
          icon: "success",
          title: "임시저장",
          text: "임시저장 완료",
          confirmButtonColor: "dodgerBlue",
          iconColor: "dodgerBlue",
        });
      }
      navigate("/request/addfile", { state: response.data });
    } catch (err) {
      console.log(err);
    }
  };

  // 이전 데이터로 실행
  const goWithPrevData = async () => {
    let tempObj = {};
    tempObj.taskGroupId = state.id[0].id;
    tempObj.managerName = state.form.staffName;
    tempObj.managerDuty = state.form.staffPosition;
    tempObj.managerEmail = state.form.staffEmail;
    tempObj.managerTel = state.form.staffNum;
    tempObj.applyFormValues = state.prevData.applyFormValues;
    if (
      menuData.filter((el) => el.name !== state.id[0].workflowName).length > 0
    ) {
      tempObj.prdName = state.prevData.prdName;
      tempObj.modelName = state.prevData.modelName;
    }
    tempObj.confVersion = state.prevData.confVersion;
    try {
      // const response = await axios.post("/api/apply-proc", tempObj);
      navigate("/request/addfile", { state: state.prevData.id });
    } catch (err) {
      console.log(err);
    }
  };
  const getMenuData = async () => {
    try {
      const response = await axios.get("/api/workflow");
      setMenuData(response.data.data.filter((el) => el.category === 1));
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <>
      {showModal ? (
        <div className="popup_bg_bbs" onClick={closeModal}>
          <div
            className="password_change"
            style={{ width: "800px" }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="pophead_bbs">
              <h1>이전선택 데이터</h1>
            </div>
            <div className="password_change_inner">
              <table className="table_new_wrap_">
                <tbody>
                  {(state.id[0].type === 1 || state.id[0].type === 4) &&
                  menuData.filter((el) => el.name !== state.id[0].workflowName)
                    .length > 0 ? (
                    <>
                      <tr>
                        <th className="eid">제품명</th>
                        <td className="eid_btn">{state?.prevData?.prdName}</td>
                      </tr>
                      <tr>
                        <th className="eid">모델명</th>
                        <td className="eid_btn">
                          {state?.prevData?.modelName}
                        </td>
                      </tr>
                    </>
                  ) : null}

                  {state.prevData.applyFormValues.map((e, idx) => {
                    return (
                      <Fragment key={idx}>
                        <tr>
                          <th className="eid">{e.entryName}</th>
                          <td className="eid_btn">{e.description}</td>
                        </tr>
                      </Fragment>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <div className="password_change_inner">
              <div className="btns_wrap">
                <button className="btn_color" onClick={closeModal}>
                  <span className="material-icons">새로선택</span>
                </button>
                <button
                  type="button"
                  className="btn_color"
                  onClick={goWithPrevData}
                >
                  <span className="material-icons">현재 데이터로 진행</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      ) : null}
      <div className="step1_Authinfo">
        <div className="contain my_Authinfo_wrap">
          <form className="my_Authinfo">
            <h1>
              {/* {state.id[0].workflowName}
              {state.acceptNum === undefined ? "" : "지위승계"} 신청{" "}
              {state.id[0].type === 9 ? " 이의·불만·분쟁 처리 신청" : null} */}
              {state.id[0].workflowName}
              {state.acceptNum === undefined ? (
                <>
                  {state.id[0].type === 9
                    ? " 이의·불만·분쟁 처리 신청"
                    : "신청(기관정보)"}
                </>
              ) : (
                <span style={{ marginLeft: "1rem" }}>
                  지위승계 접수번호 : {state?.acceptNum}
                </span>
              )}
            </h1>
            <hr />
            {(state.id[0].type === 1 || state.id[0].type === 4) &&
            menuData.filter((el) => el.name !== state.id[0].workflowName)
              .length > 0 ? (
              <>
                <fieldset style={{ width: "600px" }}>
                  <legend>제품명</legend>
                  <div className="input_wrap">
                    <input
                      name="prdName"
                      type="text"
                      className="input_box"
                      onChange={textFieldHandler}
                      placeholder="제품명을 입력해주세요"
                    />
                  </div>
                </fieldset>

                <fieldset style={{ width: "600px" }}>
                  <legend>모델명</legend>
                  <div className="input_wrap">
                    <input
                      type="text"
                      name="modelName"
                      className="input_box"
                      onChange={textFieldHandler}
                      placeholder="모델명을 입력해주세요"
                    />
                  </div>
                </fieldset>
              </>
            ) : null}

            {formData.map((e, idxx) => {
              const filter0 = e.items.filter((el) => el.type === 0);
              const filter1 = e.items.filter((el) => el.type === 1);
              const filter2 = e.items.filter((el) => el.type === 2);
              return (
                <Fragment key={idxx}>
                  <fieldset
                    style={{
                      width: "600px",
                      marginBottom: "1rem",
                      borderColor: "#ddd",
                    }}
                  >
                    <legend>{e.title}</legend>
                    {/* 텍스트박스 */}
                    {filter0.map((el, idx1) => {
                      return (
                        <Fragment key={idx1}>
                          <div className="input_wrap">
                            <TextareaAutosize
                              // type="text"
                              style={{
                                border: "1px solid #ddd",
                                fontSize: "1rem",
                              }}
                              minRows={1}
                              // rows={1}
                              className="input_box"
                              placeholder={el.name}
                              onChange={tonChangeHandler(el, e.title)}
                            />
                          </div>
                        </Fragment>
                      );
                    })}
                    {/* 라디오박스 */}
                    {filter1.map((el, idx2) => {
                      return (
                        <Fragment key={idx2}>
                          <fieldset>
                            <div className="radio_">
                              <input
                                type="radio"
                                name={el.entryId}
                                id={el.name}
                                value={el.id}
                                onChange={tradioHandler(el, e.title)}
                              />

                              <label htmlFor={el.name}>{el.name}</label>
                            </div>
                            {el?.subItems?.map((item, idx) => {
                              if (item.type === 10)
                                return (
                                  <Fragment key={idx}>
                                    <fieldset>
                                      <legend>{item.name}</legend>
                                      <div className="input_wrap">
                                        <input
                                          type="text"
                                          className="input_box"
                                          onChange={onChangeHandler(
                                            item,
                                            e.title
                                          )}
                                          placeholder="텍스트를 입력해주세요."
                                          disabled={
                                            radioBox.filter(
                                              (el) =>
                                                el.targetId === item.parentId
                                            ).length === 1
                                              ? false
                                              : true
                                          }
                                          value={
                                            inputBox?.filter(
                                              (e) => e.targetId === item.id
                                            ).length === 1
                                              ? inputBox?.filter(
                                                  (e) => e.targetId === item.id
                                                ).description
                                              : ""
                                          }
                                        />
                                      </div>
                                    </fieldset>
                                  </Fragment>
                                );
                              if (item.type === 11)
                                return (
                                  <Fragment key={idx}>
                                    <div
                                      className="radio_"
                                      style={{ marginLeft: "1vw" }}
                                    >
                                      <input
                                        type="radio"
                                        id={item.id}
                                        name={item.parentId}
                                        value={item.id}
                                        onChange={radioHandler(item, e.title)}
                                        disabled={
                                          radioBox.filter(
                                            (el) =>
                                              el.targetId === item.parentId
                                          ).length === 1
                                            ? false
                                            : true
                                        }
                                        checked={
                                          radioBox.filter(
                                            (el) => el.targetId === item.id
                                          ).length === 1
                                            ? true
                                            : false
                                        }
                                      />
                                      <label htmlFor={item.id}>
                                        {item.name}
                                      </label>
                                    </div>
                                  </Fragment>
                                );
                              if (item.type === 12)
                                return (
                                  <Fragment key={idx}>
                                    <div
                                      className="checkbox_"
                                      style={{ marginLeft: "1vw" }}
                                    >
                                      <input
                                        value={item.id}
                                        id={item.id}
                                        type="checkbox"
                                        onChange={checkboxHandler(
                                          item,
                                          e.title
                                        )}
                                        checked={
                                          cbBox?.filter(
                                            (el) => el.targetId === item.id
                                          ).length > 0
                                            ? true
                                            : false
                                        }
                                        disabled={
                                          radioBox.filter(
                                            (el) =>
                                              el.targetId === item.parentId
                                          ).length === 1
                                            ? false
                                            : true
                                        }
                                      />
                                      <label htmlFor={item.id}>
                                        {item.name}
                                      </label>
                                    </div>
                                  </Fragment>
                                );
                            })}
                          </fieldset>
                        </Fragment>
                      );
                    })}
                    {filter2.map((el, idx3) => {
                      return (
                        <Fragment key={idx3}>
                          <div className="checkbox_">
                            <input
                              id={el.id}
                              type="checkbox"
                              value={el.id}
                              checked={
                                cbBox?.filter((ele) => ele.targetId === el.id)
                                  .length > 0
                                  ? true
                                  : false
                              }
                              className="check_"
                              onChange={tcheckboxHandler(el, e.title)}
                            />
                            <label htmlFor={el.id}>{el.name}</label>
                          </div>
                          {el?.subItems?.map((item, idx) => {
                            if (item.type === 10)
                              return (
                                <Fragment key={idx}>
                                  <fieldset>
                                    <legend>{item.name}</legend>
                                    <div className="input_wrap">
                                      <input
                                        type="text"
                                        className="input_box"
                                        onChange={onChangeHandler(
                                          item,
                                          e.title
                                        )}
                                        placeholder="텍스트를 입력해주세요."
                                        disabled={
                                          cbBox.filter(
                                            (el) =>
                                              el.targetId === item.parentId
                                          ).length === 1
                                            ? false
                                            : true
                                        }
                                        value={
                                          inputBox?.filter(
                                            (e) => e.targetId === item.id
                                          ).length === 1
                                            ? inputBox?.filter(
                                                (e) => e.targetId === item.id
                                              ).description
                                            : ""
                                        }
                                      />
                                    </div>
                                  </fieldset>
                                </Fragment>
                              );
                            if (item.type === 11)
                              return (
                                <Fragment key={idx}>
                                  <div
                                    className="radio_"
                                    style={{ marginLeft: "1vw" }}
                                  >
                                    <input
                                      type="radio"
                                      id={item.id}
                                      name={item.parentId}
                                      value={item.id}
                                      disabled={
                                        cbBox.filter(
                                          (el) => el.targetId === item.parentId
                                        ).length === 1
                                          ? false
                                          : true
                                      }
                                      checked={
                                        radioBox.filter(
                                          (el) => el.targetId === item.id
                                        ).length === 1
                                          ? true
                                          : false
                                      }
                                      onChange={radioHandler(item, e.title)}
                                    />
                                    <label htmlFor={item.id}>{item.name}</label>
                                  </div>
                                </Fragment>
                              );
                            if (item.type === 12)
                              return (
                                <Fragment key={idx}>
                                  <div
                                    className="checkbox_"
                                    style={{ marginLeft: "1vw" }}
                                  >
                                    <input
                                      value={item.id}
                                      id={item.id}
                                      type="checkbox"
                                      checked={
                                        cbBox.filter(
                                          (e) => e.targetId === item.id
                                        ).length === 1
                                          ? true
                                          : false
                                      }
                                      disabled={
                                        cbBox.filter(
                                          (el) => el.targetId === item.parentId
                                        ).length === 1
                                          ? false
                                          : true
                                      }
                                      onChange={checkboxHandler(item, e.title)}
                                    />
                                    <label htmlFor={item.id}>{item.name}</label>
                                  </div>
                                </Fragment>
                              );
                          })}
                        </Fragment>
                      );
                    })}
                  </fieldset>
                </Fragment>
              );
            })}
            <div className="row">
              <div className="input_wrap submit_btn">
                <button
                  className="btn_line"
                  onClick={() => {
                    navigate("/request/institution", { state });
                  }}
                >
                  이전
                </button>
                <button
                  className="btn_color"
                  type="button"
                  onClick={tempSubmitHandler}
                >
                  다음
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}

export default Authinfo;
